module.exports = __webpack_public_path__ + "img/矢量智能对象3.8eed3d21.png";